'use client'
import React, { useState, useRef } from 'react'
import PlayIcon from '@/assets/images/icons/video-play-icon.svg';
import CloseIcon from '@/assets/images/icons/close-button.svg';
import dynamic from 'next/dynamic'
const ReactPlayer = dynamic(() => import("react-player"), { ssr: false });

interface VideoPlayerProps {
    dataSet: any | null;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ dataSet }) => {

    const [playStatus, setPlayStatus] = useState(false)
    const [play, setPlay] = useState(dataSet?.play === true ? true : false)
    const videoRef = useRef<HTMLDivElement>(null) as any
    const runTimeRef = useRef<HTMLDivElement>(null) as any

    if(dataSet?.video_link && dataSet.video_link?.link_type !=="Any") {
        const videoId = dataSet.video_link.url;
            if(play === false || !play) {
                if(!dataSet?.play) {
                return (
                    <div className="video-player" ref={videoRef} >
                        <div className="hover:opacity-60 cursor-pointer" onClick={()=>{setPlayStatus(true); setPlay(true)}}>
                        {/* eslint-disable-next-line @next/next/no-img-element */}
                        <img className="poster" src={dataSet.image.url} alt={dataSet.image.alt} />
                            <div className="bg-orange h-[56px] flex justify-end items-center relative">
                                <div className="text-white absolute left-8 text-[18px]" ref={runTimeRef}>{dataSet.runtime}</div>
                                <ul className="pl-[45px] pr-[45px] py-0 m-0">
                                    <li id="startPlayer" className="play-icon" onClick={()=>{setPlayStatus(true); setPlay(true)}}><PlayIcon /></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                )
                }
            }
            else {
                return (
                    <div className="fixed top-0 left-0 bottom-0 right-0 bg-white/80 backdrop-blur-sm z-20" ref={videoRef} >
                        <div className="max-w-[156dvh] mx-auto max-h-[100dvh]">
                        <div className="flex z-[100] absolute cursor-pointer right-4 md:right-8 lg:right-12 top-4 md:rop-8 lg:top-12 bg-black/40 rounded-full w-[50px] h-[50px] items-center justify-center" onClick={()=>{setPlay(false); setPlayStatus(false)}}><CloseIcon/></div>
                        <div className="h-[100dvh] px-4 md:px-8 lg:px-12 flex items-center">
                            <div className="w-full h-[56dvw] max-h-[90dvh]">
                                <ReactPlayer
                                    url={videoId}
                                    playing={playStatus}
                                    controls={true}
                                    playsinline={false}
                                    width={'100%'}
                                    height={'100%'}
                                />
                            </div>
                        </div>
                        </div>
                    </div>
                )
            }
        }
        else {
            return (
                <div className="videoRef-player padding-bottom" ref={videoRef} >
                    <div className="videoRef-area">
                        {/* eslint-disable-next-line @next/next/no-img-element */}
                        <img src={dataSet.image.url} alt={dataSet.image.alt} />
                    </div>
                </div>
            )
        }
}

export default VideoPlayer